import React, { useMemo } from "react";
import styled from "styled-components";

/* Reuse the same colors as AdminLayout */
const theme = {
  brand: "#3dccc7",
  accent: "#ff914d",
  white: "#f1f1f1",
  subtext: "#d6d9de",
  card: "#0f1b2d",
  border: "#1e293b",
};

const Wrap = styled.div`
  display: grid;
  gap: 18px;
`;

/* Top stat cards */
const Grid4 = styled.div`
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(4, minmax(200px, 1fr));
  @media (max-width: 1200px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 640px) { grid-template-columns: 1fr; }
`;

const Card = styled.div`
  border: 1px solid ${theme.border};
  background: linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01));
  border-radius: 16px;
  padding: 16px;
  display: grid;
  gap: 10px;
`;

const Label = styled.div`
  font-size: 13px;
  color: ${theme.subtext};
  letter-spacing: .3px;
`;

const ValueRow = styled.div`
  display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap;
`;

const Value = styled.div`
  font-size: clamp(22px, 2.8vw, 28px);
  font-weight: 800;
  color: ${theme.white};
`;

const Delta = styled.span`
  font-size: 12px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 999px;
  color: #1a1a1a;
  background: ${({ $up }) => ($up ? "#6ee7b7" : "#fecaca")};
`;

export default function Dashboard() {
  // Example data (replace with API data later)
  const stats = useMemo(
    () => [
      { label: "Total Users", value: "12,458", delta: "+4.3%", up: true },
      { label: "Active Sessions", value: "1,208", delta: "+2.1%", up: true },
      { label: "Email Conversions", value: "367", delta: "-1.2%", up: false },
      { label: "Bounce Rate", value: "27.4%", delta: "-0.8%", up: true },
    ],
    []
  );

  return (
    <Wrap>
      <Grid4>
        {stats.map((s, i) => (
          <Card key={i}>
            <Label>{s.label}</Label>
            <ValueRow>
              <Value>{s.value}</Value>
              <Delta $up={s.up}>{s.delta}</Delta>
            </ValueRow>
          </Card>
        ))}
      </Grid4>
    </Wrap>
  );
}
